// Utils
import { post } from '@shopee-user/fetch-utils';

// Constants
import { config } from '@shopee-user/platform';

// Types
import type { Event } from '@shopee-user/real-time-metrics-event';

type ReportEventsRequest = {
  events: Event[];
};

type ReportEventsResponse = {
  is_success: boolean;
};

export function reportEvents({ events }: ReportEventsRequest) {
  return post<ReportEventsResponse>(
    `${config.REAL_TIME_METRICS_REPORT_DOMAIN}/api/fe/v1/metrics/report`,
    {
      events,
    }
  );
}
